import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  OnDestroy,
  Output,
  PLATFORM_ID,
  HostListener,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location, isPlatformBrowser } from '@angular/common';
import { CampaignService } from '../../../core/services/api/campaign.service';
import { ErrorService } from '../../../core/services/error.service';
import { finalize } from 'rxjs/operators';
import { InvestmentModel } from '../../../core/models/investment/investment.model';
import { AllFileFormat, DefaultProfileImage } from '../../../core/services/constant';
import { InvestmentStatus } from '../../../core/enum/investment-status.enum';
import { ReferralCode, ReferralCodeText } from '../../../core/enum/referral-code.enum';
import { Campaign } from '../../../core/models/campaign/campaign';
import { CsvService } from '../../../core/services/csv.service';
import { FieldKey } from '../../../core/models/share/field-key';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { BlockUiService } from '../../../shared/services/blockUi/block-ui.service';
import { SortDirection } from '../../../core/enum/sort-direction.enum';
import { ShareType } from '../../../core/enum/share-type.enum';
import { CampaignStatus } from '../../../core/enum/campaign-status.enum';
import { accessSync } from 'fs';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
    selector: 'app-campaign-investor-list',
    templateUrl: './campaign-investor-list.component.html',
    styleUrls: ['./campaign-investor-list.component.scss'],
    standalone: false
})
export class CampaignInvestorListComponent implements OnInit {
  @Input() campaign: Campaign;

  @Output() onInvestorListLoaded = new EventEmitter();

  isPage: boolean = false;
  slug: string;
  campaignTitle: string;
  investments: InvestmentModel[];
  params = {
    currentPage: 1,
    take: 20, // Default for desktop
    sortBy: 'createdAt',
    sortDirection: SortDirection.Desc,
    status: '',
    referralCode: '',
    Types: '',
  };

  isMobile: boolean = false;

  isLoading: boolean = true;
  isInvitedToInvest: boolean = true;

  total: number = 0;
  defaultProfileImage = DefaultProfileImage;
  ShareType = ShareType;
  InvestmentStatus = InvestmentStatus;
  investmentStatusEntries: { key: number; value: string }[] = [];
  ShareTypeEntries: { key: number; value: string }[] = [];
  SortDirection = SortDirection; // Expose SortDirection to the template
  isNaN = isNaN; // Expose isNaN to the template
  isMultiShareType: boolean = false;
  isfilterstatuschanged: boolean = false;
  isfiltersharetypechanged: boolean = false;
  ReferralCode = ReferralCode;
  referralCodeEntries: { key: number; value: string }[] = [];
  isfilterreferralCodechanged: boolean = false;
  hasReferralCodes: boolean = false;
  copiedCode: string | null = null;
  currentitem: number = 0;
  currentlastitem: number = 0;

  sortby: string = 'sortdate';
  sortdirection: string = 'sortDesc';
  constructor(
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private campaignService: CampaignService,
    private errorService: ErrorService,
    private csvService: CsvService,
    private translateService: TranslateService,
    private blockUiService: BlockUiService,
    @Inject(PLATFORM_ID) private platform: Object,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    console.log('ngOnInit called. Initial isLoading:', this.isLoading);

    // Check if device is mobile
    this.checkDeviceType();
    this.syncSortLabels();

    if (!this.campaign?.id) {
      this.isPage = true;
      this.slug = this.activatedRoute.snapshot.params.slug;
      this.getCampaign();
      return;
    }
    this.checkismultisharetype();
    // Populate investment status entries for the dropdown
    this.populateShareTypeStatusEntries();
    // Populate investment status entries for the dropdown
    this.populateInvestmentStatusEntries();
    this.populateReferralCodeEntries();
    // Set initial state to all selected
    this.selectedStatuses = this.investmentStatusEntries.map((s) => s.key);

    this.selectedReferralCode = this.referralCodeEntries.map((s) => s.key);
    console.log(
      'Calling getCampaignInvestorList() directly from ngOnInit. isLoading:',
      this.isLoading,
    );

    this.getCampaignInvestorList(false, this.params.status, '', this.params.referralCode);
  }

  private syncSortLabels() {
    if (this.params.sortBy === 'createdAt') {
      this.sortby = 'sortdate';
    } else if (this.params.sortBy === 'pledgedAmount') {
      this.sortby = 'sortamount';
    } else {
      this.sortby = 'sortdate';
    }

    if (this.params.sortDirection === SortDirection.Asc) {
      this.sortdirection = 'sortAsc';
    } else {
      this.sortdirection = 'sortDesc';
    }
  }

  populateInvestmentStatusEntries() {
    // Convert enum to array of key-value pairs for easier iteration in template
    this.investmentStatusEntries = Object.keys(InvestmentStatus)
      .filter((key) => !isNaN(Number(key)))
      .map((key) => ({
        key: Number(key),
        value: InvestmentStatus[key],
      }));
    this.investmentStatusEntries = this.investmentStatusEntries.filter(
      (item) => item.key !== InvestmentStatus.Cancelled,
    );
    this.investmentStatusEntries = this.investmentStatusEntries.filter(
      (item) => item.key !== InvestmentStatus.PledgeCancelled,
    );
    this.investmentStatusEntries = this.investmentStatusEntries.filter(
      (item) => item.key !== InvestmentStatus.None,
    );
    const customStatusorder = [1, 6, 2, 5, 4, 7];
    //const customStatusorder=[InvestmentStatus.PendingPayment,InvestmentStatus.PaymentApprovalPending,InvestmentStatus.Paid,InvestmentStatus.RefundRequested,InvestmentStatus.Refunded,InvestmentStatus.Completed]
    this.investmentStatusEntries = this.investmentStatusEntries.sort(
      (a, b) => customStatusorder.indexOf(a.key) - customStatusorder.indexOf(b.key),
    );

    console.log('Investment status entries:', this.investmentStatusEntries);
  }

  populateShareTypeStatusEntries() {
    // Convert enum to array of key-value pairs for easier iteration in template

    for (const element of this.campaign.shareTypes) {
      this.ShareTypeEntries.push({
        key: element,
        value: ShareType[element],
      });
    }
  }

  IsStatusFilterEnable(): boolean {
    let isEnabled = false;
    if (
      this.campaign.campaignStatus == CampaignStatus.PreLive ||
      this.campaign.campaignStatus == CampaignStatus.Live ||
      this.campaign.campaignStatus == CampaignStatus.Cooling
    ) {
      isEnabled = true;
    }
    return isEnabled;
  }

  checkismultisharetype() {
    console.log('this.campaign.shareTypes.length:', this.campaign.shareTypes.length);
    if (this.campaign.shareTypes.length <= 1) {
      this.isMultiShareType = false;
      console.log('isMultiShareType:', this.isMultiShareType);
    } else {
      this.isMultiShareType = true;
      console.log('isMultiShareType:', this.isMultiShareType);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkDeviceType();
    // Reload the list with new page size if we're already displaying data
    if (this.investments && this.investments.length > 0) {
      // Reset to first page when changing device type to avoid pagination issues
      this.params.currentPage = 1;
      this.getCampaignInvestorList(false, this.params.status, '', this.params.referralCode);
    }
  }

  checkDeviceType() {
    // Check if screen width is less than 768px (standard mobile breakpoint)
    if (isPlatformBrowser(this.platform)) {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 1200;

      // Only update take parameter if the device type has changed
      if (wasMobile !== this.isMobile) {
        this.params.take = this.isMobile ? 10 : 20; // 10 records for mobile, 20 for desktop
        console.log(
          'Device type changed to:',
          this.isMobile ? 'mobile' : 'desktop',
          'Records per page:',
          this.params.take,
        );
      }
    }
  }

  formatInvestorName(fullName?: string | null): string {
    if (!fullName) return '';

    const normalized = fullName.trim().replace(/\s+/g, ' ');
    const words = normalized.split(' ').map((word) => {
      const lower = word.toLowerCase();
      if (lower === 'a/l') return 'A/L';
      if (lower === 'a/p') return 'A/P';
      return lower.replace(/(^[a-z])|([-'][a-z])/g, (m) => m.toUpperCase());
    });

    return words
      .join(' ')
      .replace(/(^|\s)a\/l(?=\s|$|[.,;:)\]])/gi, '$1A/L')
      .replace(/(^|\s)a\/p(?=\s|$|[.,;:)\]])/gi, '$1A/P');
  }

  getCampaign() {
    console.log('getCampaign started.');
    this.campaignService.getCampaign(this.slug).subscribe({
      next: (data) => {
        this.campaign = data;
        console.log(
          'API Response Processed. campaign.isCreator:',
          this.campaign?.isCreator,
          'isInvitedToInvest should be true',
        );
        console.log('isPlatformBrowser:', isPlatformBrowser(this.platform));

        // Avoid the list being ssr-ed
        if (isPlatformBrowser(this.platform)) {
          console.log('Platform is browser.');
          if (!data?.isCreator && data?.isPrivate && !data?.isInvited) {
            this.isInvitedToInvest = false;
            this.isLoading = false;
            console.log(
              'INVITE ONLY BLOCK EXECUTED (should not happen for creator). isLoading:',
              this.isLoading,
            );
            return;
          }
          console.log(
            'Calling getCampaignInvestorList from getCampaign. Current isLoading before call:',
            this.isLoading,
          );

          this.checkismultisharetype();
          // Populate investment status entries for the dropdown
          this.populateShareTypeStatusEntries();
          // Populate investment status entries for the dropdown
          this.populateInvestmentStatusEntries();
          this.populateReferralCodeEntries();
          // Set initial state to all selected
          this.selectedStatuses = this.investmentStatusEntries.map((s) => s.key);
          this.selectedReferralCode = this.referralCodeEntries.map((s) => s.key);
          this.getCampaignInvestorList(false, this.params.status, '', this.params.referralCode);
        } else {
          console.log('Platform is NOT browser.');
        }
      },
      error: (err) => {
        this.errorService.showError(err);
        this.isLoading = false;
        console.error('Error in getCampaign. isLoading:', this.isLoading, err);
      },
    });
  }

  getCampaignInvestorList(
    isReport: boolean,
    status?: string,
    Types?: string,
    referralCode?: string,
  ) {
    console.log(
      'getCampaignInvestorList called. isReport:',
      isReport,
      'status:',
      status,
      'Types:',
      Types,
      'referralCode:',
      referralCode,
    );
    if (isReport) this.blockUiService.open();
    else {
      this.isLoading = true;
      console.log('isLoading set to true in getCampaignInvestorList.');
    }

    this.campaignService
      .getCampaignInvestorList(
        this.campaign.id,
        this.params.currentPage,
        this.params.take,
        isReport,
        this.params.sortBy,
        this.params.sortDirection,
        status,
        Types,
        referralCode,
      )
      .pipe(
        finalize(() => {
          if (isReport) this.blockUiService.close();
          else {
            this.isLoading = false;
            console.log('FINALIZED getCampaignInvestorList. isLoading set to false.');
          }
        }),
      )
      .subscribe({
        next: (data) => {
          console.log('getCampaignInvestorList success.');
          if (!isReport) {
            this.investments = data.data;
            this.total = data.total;
            this.currentitem = (this.params.currentPage - 1) * this.params.take + 1;
            if (this.params.currentPage * this.params.take > this.total) {
              this.currentlastitem = this.total;
            } else {
              this.currentlastitem = this.params.currentPage * this.params.take;
            }
            this.hasReferralCodes = this.investments.some((inv) => inv.hasReferralCode);
          } else {
            let jsonData = data.data.map((item) => {
              return {
                fullName: this.formatInvestorName(item.user?.fullName) || item.user?.fullName || '',
                createdAt: moment(item.createdAt).format('D MMM YYYY'),
                shareType: ShareType[item.shareType],
                shareQuantity: item.shareQuantity,
                pledgedAmount: item.pledgedAmount,
                investmentStatus: this.translateService.instant(
                  'investment.' + InvestmentStatus[item.investmentStatus],
                ),
                referralCode: item.referralCode || '-',
              };
            });
            this.generateReport(jsonData);
          }

          this.onInvestorListLoaded.emit();
        },
        error: (err) => {
          this.errorService.showError(err);
          console.error(
            'Error in getCampaignInvestorList. isLoading (still true before finalize):',
            this.isLoading,
            err,
          );
        },
      });
  }

  generateReport(jsonData: Object[]) {
    let fieldNames: FieldKey[] = [
      { key: 'fullName', title: 'Full Name' },
      { key: 'createdAt', title: 'Invested At' },
      { key: 'shareType', title: 'Type Of Share' },
      { key: 'shareQuantity', title: 'Share Quantity' },
      { key: 'pledgedAmount', title: 'Total Invested (RM)' },
      { key: 'investmentStatus', title: 'Status' },
    ];

    if (this.hasReferralCodes) {
      fieldNames.push({ key: 'referralCode', title: 'Referral Code' });
    }

    this.csvService.downloadFile(jsonData, fieldNames, 'individual-investor');
  }

  selectedStatuses: InvestmentStatus[] = [];
  selectedReferralCode: ReferralCode[] = [];
  selectedSharetypes: ShareType[] = [];

  resetShareType() {
    this.selectedSharetypes = [];
    this.filterByShareType();
  }

  isAllShareType(): boolean {
    return this.selectedSharetypes.length === 0;
  }

  toggleAllShareType(event: any) {
    this.isfiltersharetypechanged = true;
    console.log('toggleAllShareType called', event.target.checked);
    if (event.target.checked) {
      this.selectedSharetypes = [];
    } else {
      this.selectedSharetypes = Object.keys(this.ShareType)
        .filter((key) => !isNaN(Number(key)))
        .map((key) => Number(key));
    }
    console.log('selectedStatuses after toggle:', this.selectedSharetypes);
  }

  isShareTypeSelected(shareType: ShareType): boolean {
    return this.selectedSharetypes.includes(shareType);
  }

  toggleShareType(shareType: ShareType, event: any) {
    this.isfiltersharetypechanged = true;
    console.log('toggleShareType called', shareType, event.target.checked);
    if (event.target.checked) {
      this.selectedSharetypes.push(shareType);
    } else {
      this.selectedSharetypes = this.selectedSharetypes.filter((s) => s !== shareType);
    }
    console.log('selectedShareType after toggle:', this.selectedSharetypes);
  }

  filterByShareType() {
    console.log('filterShareType called, selectedStatuses:', this.selectedSharetypes);
    if (this.isfiltersharetypechanged) {
      this.params.currentPage = 1;
    }
    if (this.selectedSharetypes.length === 0) {
      this.params.Types = null;
      console.log('Setting status to null (all statuses)');
    } else {
      this.params.Types = this.selectedSharetypes.join(',') as any; // API might expect a comma-separated string
      console.log('Setting status to:', this.params.Types);
    }
    this.isfiltersharetypechanged = false;
    this.getCampaignInvestorList(
      false,
      this.params.status,
      this.params.Types,
      this.params.referralCode,
    );
  }

  resetstatus() {
    this.selectedStatuses = this.investmentStatusEntries.map((s) => s.key);
    this.filterByStatus();
  }

  isAllStatusesSelected(): boolean {
    if (this.selectedStatuses.includes(9)) {
      return false;
    }
    return this.selectedStatuses.length === this.investmentStatusEntries.length;
  }

  toggleAllStatuses(event: any) {
    this.isfilterstatuschanged = true;
    console.log('toggleAllStatuses called', event.target.checked);
    if (event.target.checked) {
      this.selectedStatuses = this.investmentStatusEntries.map((s) => s.key);
    } else {
      this.selectedStatuses = [];
    }
    console.log('selectedStatuses after toggle:', this.selectedStatuses);
  }

  isStatusSelected(status: InvestmentStatus): boolean {
    return this.selectedStatuses.includes(status);
  }

  toggleStatus(status: InvestmentStatus, event: any) {
    this.isfilterstatuschanged = true;
    console.log('toggleStatus called', status, event.target.checked);
    if (event.target.checked) {
      this.selectedStatuses.push(status);
    } else {
      this.selectedStatuses = this.selectedStatuses.filter((s) => s !== status);
    }
    console.log('selectedStatuses after toggle:', this.selectedStatuses);
  }

  filterByStatus() {
    console.log('filterByStatus called, selectedStatuses:', this.selectedStatuses);
    if (this.isfilterstatuschanged) {
      this.params.currentPage = 1;
    }
    if (this.selectedStatuses.length === 0) {
      this.selectedStatuses = [9];
    }

    if (this.selectedStatuses.length === this.investmentStatusEntries.length) {
      this.params.status = null;
      console.log('Setting status to null (all selected)');
    } else {
      this.params.status = this.selectedStatuses.join(',') as any; // API might expect a comma-separated string
      console.log('Setting status to:', this.params.status);
    }
    this.isfilterstatuschanged = false;
    this.getCampaignInvestorList(
      false,
      this.params.status,
      this.params.Types,
      this.params.referralCode,
    );
  }

  sortInvestors(sortBy: string) {
    if (this.params.sortBy === sortBy) {
      this.params.sortDirection =
        this.params.sortDirection === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc;
    } else {
      this.params.sortBy = sortBy;
      this.params.sortDirection = SortDirection.Desc;
    }
    this.syncSortLabels();
    this.filterByStatus();
    this.filterByShareType();
    this.filterByReferralCode();
  }

  checkSortStatus(sortBy: string): number {
    // 1=asc
    // 2=desc
    // 3=default
    if (this.params.sortBy !== sortBy) return 3;

    if (this.params.sortDirection === SortDirection.Asc) return 1;
    if (this.params.sortDirection === SortDirection.Desc) return 2;
    return 3;
  }

  // Function to maintain the original order of enum values in the keyvalue pipe
  keepOriginalOrder = (a: any, b: any): number => {
    console.log('keepOriginalOrder called with:', a, b);
    return 0;
  };

  populateReferralCodeEntries() {
    this.referralCodeEntries = Object.values(ReferralCode)
      .filter(
        (key) => typeof key === 'number' && key !== ReferralCode.All && key !== ReferralCode.None,
      )
      .map((key) => ({
        key: key as number,
        value: ReferralCodeText[key as ReferralCode],
      }));

    console.log('Referral code entries:', this.referralCodeEntries);
  }

  isAllReferralCodeSelected(): boolean {
    if (this.selectedReferralCode.includes(9)) {
      return this.selectedReferralCode.length - 1 === this.referralCodeEntries.length;
    }
    return this.selectedReferralCode.length === this.referralCodeEntries.length;
  }

  toggleAllReferralCode(event: any) {
    this.isfilterreferralCodechanged = true;
    console.log('toggleAllReferralCode called', event.target.checked);

    if (event.target.checked) {
      this.selectedReferralCode = this.referralCodeEntries.map((s) => s.key);
    } else {
      this.selectedReferralCode = [];
    }

    console.log('selectedReferralCode after toggle:', this.selectedReferralCode);
  }

  isReferralCodeSelected(referralCode: ReferralCode): boolean {
    return this.selectedReferralCode.includes(referralCode);
  }

  toggleReferralCode(referralCode: ReferralCode, event: any) {
    this.isfilterreferralCodechanged = true;
    console.log('toggleStatus called', referralCode, event.target.checked);
    if (event.target.checked) {
      this.selectedReferralCode.push(referralCode);
    } else {
      this.selectedReferralCode = this.selectedReferralCode.filter((s) => s !== referralCode);
    }
    console.log('selectedReferralCode after toggle:', this.selectedReferralCode);
  }

  filterByReferralCode() {
    console.log('filterByReferralCode called, selectedReferralCode:', this.selectedReferralCode);
    if (this.isfilterreferralCodechanged) {
      this.params.currentPage = 1;
    }

    if (this.selectedReferralCode.length === 0) {
      this.selectedReferralCode = [9];
    }
    if (this.selectedReferralCode.length === this.referralCodeEntries.length) {
      this.params.referralCode = null;
      console.log('Setting referralCode to null (both Yes and No selected)');
    } else {
      this.params.referralCode = this.selectedReferralCode.join(',');
      console.log('Setting referralCode to:', this.params.referralCode);
    }

    this.isfilterreferralCodechanged = false;
    this.getCampaignInvestorList(
      false,
      this.params.status,
      this.params.Types,
      this.params.referralCode,
    );
    this.selectedReferralCode = this.selectedReferralCode.filter((s) => s !== 9);
  }

  resetReferralCode() {
    this.selectedReferralCode = this.referralCodeEntries.map((s) => s.key);
    this.filterByReferralCode();
  }

  resetAllFilters(event: any) {
    event.preventDefault();
    event.stopPropagation();

    this.resetstatus();
    this.resetReferralCode();
  }

  applyAllFilters() {
    this.filterByStatus();
    this.filterByReferralCode();
    this.getCampaignInvestorList(
      false,
      this.params.status,
      this.params.Types,
      this.params.referralCode,
    );
  }

  copyReferralCode(code: string) {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        this.copiedCode = code;
        this.snackBar.open('Referral code copied!', '', { duration: 1200 });

        // Reset visual feedback after 1s
        setTimeout(() => {
          this.copiedCode = null;
        }, 1000);
      })
      .catch((err) => console.error('Failed to copy referral code: ', err));
  }
}
